// extracted by mini-css-extract-plugin
module.exports = {"container":"PostBreadcrumbs-module--container--1iCG0","list":"PostBreadcrumbs-module--list--1CdtO"};